export function handleHomeLoginBtn() {
    const loginBtn = document.querySelector('.fy-home-login-btn') as HTMLButtonElement;
    const loginNavBtn = document.querySelector('.btn-icon-login-register') as HTMLAnchorElement
    if (loginBtn) {
        loginBtn.addEventListener('click', e => {
            loginNavBtn.click();
        })
    }
}